/** `/conocimiento`: la biblioteca real (biblioteca.html) con el cliente del Studio. */
import { useSearch } from "@tanstack/react-router";
import { studio } from "../../api/client";
import { Biblioteca } from "./Biblioteca";

export function BibliotecaPage() {
  const s = useSearch({ strict: false }) as { estado?: string; uso?: string; q?: string };
  return <Biblioteca api={studio.biblioteca} telemetria={studio.telemetriaBiblioteca} estado={s.estado} uso={s.uso} q={s.q} />;
}
